import {
  CommonCompanyEquityInformationDocumentSerializer,
  CompanyEquityInformationSerializer,
} from '@bcba/serializers';
import { FileMimeType } from '@bcba/types';

export const defaultValueShape = [
  {
    file: { mimeType: undefined, s3TempKey: undefined, type: undefined },
    keepOriginal: false,
  },
];

const mapDocument = (doc?: CommonCompanyEquityInformationDocumentSerializer) =>
  doc
    ? {
        documentUuid: doc.documentUuid || '',
        uuid: doc.uuid || '',
        keepOriginal: true,
        originalName: doc.originalFileName,
        bcIdentifier: doc.identifier || '',
        expirationDate: doc.expirationDate,
      }
    : undefined;

export const mapEquityInfoSerializerToLocalState = (
  response: CompanyEquityInformationSerializer,
) => {
  const balanceDocuments = response.balanceDocuments?.length
    ? response?.balanceDocuments.map(mapDocument)
    : defaultValueShape;
  const additionalDocuments = response.additionalDocuments?.length
    ? response?.additionalDocuments.map(mapDocument)
    : defaultValueShape;

  const dto = {
    uuid: response.uuid,
    balanceDocuments,
    additionalDocuments,
  };

  return dto;
};

export const mapDocumentToSave = (doc: any) => {
  return {
    uuid: doc?.uuid,
    keepOriginal: doc?.keepOriginal,
    file: doc?.file
      ? {
          s3TempKey: doc?.file?.s3TempKey ?? '',
          name: doc?.file?.name,
          mimeType: doc?.file?.mimeType as FileMimeType,
        }
      : undefined,
    originalName: doc?.originalName ?? null,
  };
};
